import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { Visit } from "src/app/interfaces/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "Visit";
export const VisitService = {
	endpoint,
	createSingle: async (data: Visit) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	forVisitor: async (id: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/ForVisitor/${id}`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: Visit) => await Service.updateSingleById(endpoint, id, data),
}